<mat-expansion-panel appearance="outlined" expanded="true" class="mat-elevation-z0">
  <mat-expansion-panel-header>
    @if(matterId){
      <mat-panel-title> Matter Details - {{clientMatterContactDetails?.matterNumber}} </mat-panel-title>
    }
    @else{
      <mat-panel-title> About Us </mat-panel-title>
    }
  </mat-expansion-panel-header>

  <div class="d-flex justify-content-center" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>

  <div *ngIf="!loading">

    <!-- Matter Details -->
    @if(matterId){
      <div class="about-us-grid">
        <div>Reference</div>
        <div>{{clientMatterContactDetails?.matterNumber}}</div>
        <div>Description</div>
        <div>{{clientMatterContactDetails?.matterName}}</div>
        <div>Status</div>
        <div>{{clientMatterContactDetails?.matterStatus}}</div>
        <div>Contact Person</div>
        <div>{{clientMatterContactDetails?.name}}</div>
        <div>Phone Number</div>
        <div>{{clientMatterContactDetails?.phone}}</div>
      </div>
    }
    <!-- Standard Homepage Details -->
    @else {
      <div class="about-us-grid">
        <div>Our Firm</div>
        <div>{{clientMatterContactDetails?.businessName}}</div>
        <div>Contact Person</div>
        <div>{{clientMatterContactDetails?.name}}</div>
        <div>Phone Number</div>
        <div>{{clientMatterContactDetails?.phone}}</div>
        <div>Email</div>
        <div>{{clientMatterContactDetails?.email}}</div>
      </div>
    }
  </div>
</mat-expansion-panel>
